module.exports = __webpack_public_path__ + "static/media/S1-41-Nergyzzak-Ev-cod77.6078d941.png";